module.exports = __webpack_public_path__ + "assets/img/1413.fe18aeb6.png";